import React, {useEffect, useState} from 'react'
import Modal from "../widget/Modal";
import {useTranslation} from "react-i18next";
import useBlocker from "../../hooks/router/useBlocker";
import handleOnUnloadEvent from "../../hooks/router/handleOnUnloadEvent";
import PropTypes from "prop-types";
import {useNavigate} from "react-router-dom";

const FormContainer = (props) => {

    const {t} = useTranslation();
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [nextLocation, setNextLocation] = useState("");
    const warnEditedRef = React.useRef(false);
    const navigate = useNavigate();
    useEffect(() => {
        window.addEventListener('beforeunload', handleOnUnloadEvent)

        return () => window.removeEventListener('beforeunload', handleOnUnloadEvent)
    }, [])

    const stayOnPage = () => {
        setShowConfirmDialog(false);
    }

    const leavePage = () => {
        window.removeEventListener('beforeunload', handleOnUnloadEvent)
        nextLocation && navigate(nextLocation, {replace: true});
        setShowConfirmDialog(false);
    }

    useEffect(() => {
        warnEditedRef.current = props.isEdited();
    }, [props.isEdited()]);

    useBlocker((redirect) => {
        if (warnEditedRef.current) {
            setNextLocation(redirect.pathname);
            setShowConfirmDialog(true);
        } else {
            navigate(redirect.pathname, {replace: true});
        }
    }, props.isEdited())

    return (
        <div>
            <form onSubmit={(event) => {
                event.preventDefault();
                warnEditedRef.current = false;
                props.onSubmit();
            }}>
                {props.children}
            </form>
            <Modal title={t('leave_page_title')}
                   content={t('leave_page_question')}
                   showPopup={showConfirmDialog}
                   label={t('leave')}
                   stayLabel={t('stayLabel')}
                   leaveLabel={t('leaveLabel')}
                   confirmButtonColor={'primary'}
                   onClose={() => stayOnPage()}
                   onDelete={() => leavePage()}>
            </Modal>
        </div>

    )

}

FormContainer.propTypes = {
    isEdited: PropTypes.func,
    onSubmit: PropTypes.func
}

export default FormContainer
